// 주문 내역 헤더 컴포넌트
import svgPaths from '../../imports/svg-o5inl1a2mp';
import { useLanguage } from '@/contexts/AppContext';
import type { OrderHistoryTranslations } from './types';

interface OrderHistoryHeaderProps {
  onBack: () => void;
  translations: OrderHistoryTranslations;
}

export function OrderHistoryHeader({ onBack, translations }: OrderHistoryHeaderProps) {
  const { language } = useLanguage();
  return (
    <div className="sticky top-0 z-50 bg-primary">
      <div className="flex items-center justify-center relative h-[50px] px-[20px]">
        <button
          onClick={onBack}
          className="absolute left-[20px] flex items-center justify-center w-[32px] h-[32px]"
        >
          <svg className="w-[12px] h-[21px]" fill="none" preserveAspectRatio="none" viewBox="0 0 12 21">
            <path d={svgPaths.p27596280} fill="white" />
          </svg>
        </button>
        <h1
          className={`font-['Noto_Sans:Bold',_'Noto_Sans_KR:Bold',_sans-serif] font-bold text-[16px] text-white tracking-[-0.32px] text-center ${language !== 'ko' ? 'uppercase' : ''}`}
          style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
        >
          {translations.title}
        </h1>
      </div>
    </div>
  );
}
